/// <reference path="./typings/@cian/event-bus/index.d.ts" />

export function getEventBusIfDefined(): CianEventBus.ICianEventBus | undefined {
  if (window.ceb && typeof window.ceb === 'object' && typeof window.ceb.emit === 'function' && typeof window.ceb.subscribe === 'function') {
    return window.ceb;
  }

  return;
}

export function getEventBusOrThrow(): CianEventBus.ICianEventBus {
  if (!window.ceb) {
    throw new Error('Event bus not found in window.ceb');
  }

  if (typeof window.ceb !== 'object' || typeof window.ceb.emit !== 'function' || typeof window.ceb.subscribe !== 'function') {
    throw new Error('Invalid event bus found in window.ceb');
  }

  return window.ceb;
}
